import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ParamServicesService } from 'src/app/services/param-services.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.page.html',
  styleUrls: ['./products.page.scss'],
})
export class ProductsPage implements OnInit, OnDestroy {
  public loaded = false;
  public cartIcon = '';
  private _subscription: Subscription = new Subscription();

  constructor(
    private paramSv: ParamServicesService
  ) { }

  ngOnInit() {

    if(this.paramSv.styles){
      this.setCartStyle();
    }
    
    this._subscription.add(this.paramSv.emitImagesObs.subscribe((item: any) => {
      if(item === 'finish'){
        this.setCartStyle();
      }
    }));
  }

  setCartStyle(){
    const cart = this.paramSv.styles.find(item => item.text === 'Carrito')?.selected;
    this.cartIcon = './assets/icons/' + (cart || 'carrito2.svg');

  }

  ionViewWillEnter(){
    this.loaded = true;
  }

  ionViewWillLeave(){
    this.loaded = false;
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }
}
